import React from 'react'
import { Route, Routes } from 'react-router-dom'
import PrivateRoute7  from '../../app/routes/PrivateRoute7'

import ListInnovation from './ListInnovation'

import EditInnovation from './EditInnovation'
import NewInnovation from './NewInnovation'

const SpecialistInnovationRoutes = () => {

  return (
    <Routes>
        <Route path="/" element={<PrivateRoute7><ListInnovation /></PrivateRoute7>} />
        <Route path="edit-innovation" element={<PrivateRoute7><EditInnovation /></PrivateRoute7>} />
        <Route path="new-innovation" element={<PrivateRoute7><NewInnovation /></PrivateRoute7>} />
    </Routes>
  )
}

export default SpecialistInnovationRoutes